import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logoImage from '../img/logo.png';
import { isDyslexiaModeEnabled, setDyslexiaModeEnabled } from '../services/accessibilityPrefs';

function Header() {
  const [dyslexiaMode, setDyslexiaMode] = useState(false);

  useEffect(() => {
    const enabled = isDyslexiaModeEnabled();
    setDyslexiaMode(enabled);
    setDyslexiaModeEnabled(enabled);
  }, []);

  const handleToggleDyslexiaMode = () => {
    const next = !dyslexiaMode;
    setDyslexiaMode(next);
    setDyslexiaModeEnabled(next);
  };

  return (
    <header className="institute-header">
      <div className="header-wrapper">
        <div className="header-content">
          <Link to="/" className="logo-link">
            <img
              src={logoImage}
              alt="Institute Logo"
              className="logo"
            />
          </Link>
          <div className="header-text">
            <h3 className='header'>KRC - Online Public Access Catalog</h3>
            {/* <p className="tagline">IIT Hyderabad</p> */}
          </div>
          <button
            type="button"
            className={`a11y-toggle-btn ${dyslexiaMode ? 'a11y-toggle-btn--active' : ''}`}
            onClick={handleToggleDyslexiaMode}
            aria-pressed={dyslexiaMode}
            title="Toggle dyslexia-friendly reading mode"
          >
            <span aria-hidden="true">🔤</span>
            <span className="a11y-btn-text">{dyslexiaMode ? ' Reading mode: On' : ' Reading mode'}</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
